import React, { Component } from 'react'
import { myEventsListener } from '../../firebase/database/handleMyEvents'
import { connect } from 'react-redux'
import uuid from 'uuid/v4'
import EventDetails from './EventDetails'
import moment from 'moment'
import 'moment/locale/de'
import Paper from '@material-ui/core/Card'
import DefaultPage from '../../Container/Layout/DefaultPage'
import arraySort from 'array-sort'


const styles = {
    marginLeft: '10px',
    eventItems: {
        
    },
    eventItemWrapper: {
        width: '100%',

    },
    eventItem: {
        //border: '2px solid gray',
        margin: '0 auto',
        boxShadow: '2px 2px 2px',
        padding: '2px',
        marginBottom: '8px',
        cursor: 'pointer',
        textAlign: 'center',  
    },

    del: {
        color: 'white',
        textWeight: 'bold',
        padding: '4px',
        marginLeft: '8px',
        backgroundColor: 'red',
        cursor  : 'pointer'
    },
    headline: {
        color: '#3f51b5'
    },
    red: {
        color: 'red',
        fontWeight: 'bold'
    }
}

class EventList extends Component {
    constructor(props) {
        super(props);
        this.state   = {
          events: null,
          view: null,
          selectedEvent: null,
          setFilter: false,
        };

        this.toggleView = this.toggleView.bind(this)
      }
    
    async componentDidMount(){
        const { myEventsFbListener, authUserId } = this.props;
        await myEventsFbListener('add', authUserId)
       
        moment.locale('de')
        this.setState({setFilter: true})
    }
    componentWillUnmount() {
        const { myEventsFbListener, authUserId } = this.props
        myEventsFbListener('remove', authUserId)
    }

    toggleView = (pageToView, event) => {
        this.setState({selectedEvent: event})
        this.setState({view: pageToView});
        this.props.onOpenEventDetails('0');
        
    }

render() {
    const {events} = this.props
    const sortedEvents = arraySort(events, 'data.date')
    const { view } = this.state
    const title = view==='EVENT_DETAILS' ? 'Mein Hilfebedarf' : 'Mein Hilfebedarf'
    return (
    <DefaultPage headline={{headlineText: title}}>
       {view==='EVENT_DETAILS'
            ? <EventDetails doToggleView={this.toggleView} event={this.state.selectedEvent}/>
            : <EventItems eventItems={sortedEvents} doToggleView={this.toggleView} authUserId={this.props.authUserId}/>
       }
    </DefaultPage>
)}}

const mapDispatchToProps = (dispatch) => ({
    myEventsFbListener: (state, userId) => myEventsListener(state, userId),
    onOpenEventDetails: (value) => dispatch({type: 'CHANGE_VIEW', value})
  });

const mapStateToProps = (state) => ({
    events: state.eventState.myEvents,
    authUserId: state.sessionState.authUser.uid,
    myEventsCount: state.counterState.myEvents
  });

const renderTime = (timeRange, time) => {
    if(timeRange==='onDate') {
        if(time!=='Nach Vereinbarung') {
            return <h3 style={{color: 'red'}}>Uhrzeit: {time}</h3>
        } else {
            return <h3>Uhrzeit nach Vereinbarung</h3>
        }
    }
}
    const EventItems = (props) => {
        const {eventItems} = props
        // message if no fb events available
        if(eventItems===null)return <div>Sie haben noch keinen Hilfebedarf erstellt</div>
        return (
            eventItems.map(eventItem => {
                return (
                    <div key={uuid()} style={styles.eventItemWrapper}>
                        <Paper onClick={()=>props.doToggleView('EVENT_DETAILS', eventItem.data)} key={eventItem.data.id} style={styles.eventItem} >
                            {eventItem.data.timeRange==='onDate'
                                ? <h3 style={styles.red}>An einem bestimmten Datum</h3>
                                :  <h3>Nach Vereinbarung bis</h3>
                            }
                            <h3>{moment(eventItem.data.date).format('dddd')+' '+ moment(eventItem.data.date).format('L')} </h3>
                            {renderTime(eventItem.data.timeRange, eventItem.data.time)}
                            {eventItem.data.pkw
                                ? <h3 style={{color: 'red'}}>PKW erforderlich</h3>
                                : null
                            }
                            <h3 style={{backgroundColor: '#eceff1'}}>Für: {eventItem.data.task}</h3>
                            <h3>in {eventItem.data.ort}</h3>
                        </Paper> 
                        {//authUserId===eventItems[key].userId
                        //  ?  <span style={styles.del} onClick={()=>doDelEvent(eventItems[key].id)}>Löschen</span>
                        //  : null
                        }
                    </div>
                )
            })           
        )
    }

  

  export default connect(mapStateToProps, mapDispatchToProps) (EventList);


// WEBPACK FOOTER //
// ./src/Components/Events/EventList.js